module.exports = __webpack_public_path__ + "img/me.4c6a3d62.png";